import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { uniqBy } from 'lodash';
import {
  NitroButton,
  NitroLoading,
  NitroSnackbar,
  NitroNavBar,
} from 'nitro-components';

import { notify, closeNotify } from '@src/components/libs/notification';
import DisableCover from '@src/components/libs/disabled';
import * as Routes from '@src/routes/const';
import AdminAPI from '@src/api/AdminApi';

import UserRole from './UserRole';
import UserRestrictions from './UserRestrictions';
import UserClaims from './UserClaims';
import UserDetails from './UserDetails';

export const MainBody = styled.div`
  padding: 20px 60px;

  display: flex;
  flex-direction: column;
`;

export const SubmitSection = styled.section`
  width: 200px;
  margin-left: auto;
  margin-top: 10px;
`;

const Container = styled.div`
  margin-top: 20px;
  transition: opacity 2s;
`;

class UserEdit extends Component {
  constructor(props) {
    super(props);

    this.userDetails = {};
    this.UserClaims = [];
    this.onUserDetailsChangeFunc = this.onUserDetailsChangeFunc.bind(this);
    this.submitUser = this.submitUser.bind(this);
    // this.rolesChanges = this.rolesChanges.bind(this);
    this.IsOperationSuccess = false;
  }

  state = {
    isNew: false,
    userLoaded: false,
    isLoading: false,
    isBizEntityLoaded: false,
    isClaimsLoaded: false,
    isRolesLoaded: false,
    activeUser: {
      businessEntityId: 0,
    },
    bizEntityDataSource: [],
    availableCountries: [],
    claims: [],
    allRoles: [],
    newRoles: [],
    newRestrictions: [],
  };

  async componentWillMount() {
    this.getBizEntities();
    this.getClaims();

    let newState = {};
    if (this.props.params.id !== 'new') {
      this.getUser(this.props.params.id);
    } else {
      newState = { isNew: true };
    }
    this.setState(newState);
  }

  onUserDetailsChangeFunc = (bizEntId, countryCode) => {
    this.setState({
      activeUser: {
        businessEntityId: bizEntId,
      },
    });

    this.getAllRoles(bizEntId, countryCode);
  };

  setbizEntOpts = bizEntOpts => {
    const availCtries = uniqBy(bizEntOpts, 'CountryCode').map(x =>
      x.CountryCode.toUpperCase()
    );

    this.setState({
      bizEntityDataSource: bizEntOpts,
      availableCountries: availCtries,
      isBizEntityLoaded: true,
    });
  };

  setLoading = status => {
    this.setState({
      isLoading: status,
    });
  };

  getAllRoles = (businessEntityId, countryCode) => {
    if (businessEntityId > 0 && countryCode) {
      this.setLoading(true);
      AdminAPI.getAllRoles(businessEntityId, countryCode).then(data => {
        this.setLoading(false);
        this.setState({
          allRoles: data,
          isRolesLoaded: true,
        });
      });
    }
  };

  getClaims = () => {
    this.setLoading(true);
    AdminAPI.getClaims()
      .then(data => {
        this.setLoading(false);
        this.setState({
          isClaimsLoaded: true,
          claims: data,
        });
      })
      .catch(err => err);
  };

  getUser = userid => {
    this.setLoading(true);
    AdminAPI.getUser(userid).then(data => {
      this.userLoaded(data);
    });
  };

  getBizEntities = () => {
    AdminAPI.getBusinessEntities()
      .then(data => {
        this.setbizEntOpts(data);
      })
      .catch(err => err);
  };

  getUserClaims = () => {
    const userClaimsref = this.userClaimsRef.getWrappedInstance().state
      .UserClaims;

    const userClaims = userClaimsref.map((ea, idx) => ({
      type: ea.type,
      value: ea.value,
    }));

    return userClaims;
  };

  getUserRoles = () => {
    const rolesVal = this.userRoleRef.getWrappedInstance().state.userRoles;
    const roles = rolesVal.map(sg => sg.id);
    return roles;
  };

  getCompanyCodes = () => {
    const compCodeResVal = this.state.newRestrictions;

    let userCompanyCodes = [];

    if (compCodeResVal && compCodeResVal.length > 0) {
      userCompanyCodes = compCodeResVal.map(item => ({
        companyCode: item.companyCode,
        countryCode: item.countryCode,
        restrictions: item.restrictions
          .filter(re => {
            // TODO: re.value should be re.values
            if (re.values) {
              return true;
            }
            return false;
          })
          .map((value, i) => ({
            typeId: value.typeId,
            values: value.values,
          })),
      }));
    }
    return userCompanyCodes;
  };

  getUserDetails = () => {
    const userDetailsVal = this.userDetailsRef.getValue();
    const userdetails = {
      userName: userDetailsVal.userName,
      firstName: userDetailsVal.firstName,
      lastName: userDetailsVal.lastName,
      mobile: userDetailsVal.mobile,
      businessEntityId: userDetailsVal.businessEntityId,
      countryCode: userDetailsVal.countryCode,
      employerCompanyCode: userDetailsVal.employerCompanyCode,
      employerCompanyName: userDetailsVal.employerCompanyName,
      isActive: userDetailsVal.isActive,
      zoneName: userDetailsVal.zoneName,
      zoneId: userDetailsVal.zoneId,
    };

    return userdetails;
  };

  submitUser = e => {
    const userId = this.props.params.id;
    let userPost = {};
    if (userId !== 'new') {
      userPost.userId = userId;
    }
    const userDetails = this.getUserDetails();
    const userCompanyCodes = this.getCompanyCodes();
    const roles = this.getUserRoles();
    const userClaims = this.getUserClaims();

    userPost = Object.assign({}, userPost, {
      ...userDetails,
      userCompanyCodes,
      roles,
      userClaims,
    });
    this.updateUser(userPost);
  };

  updateUser = userModel => {
    const { router } = this.context;
    const { notify } = this.props;

    this.setLoading(true);
    AdminAPI.updateUser(userModel)
      .then(data => {
        this.setLoading(false);
        if (data.success) {
          notify({
            title: 'User saved successfully',
          });
          this.goBack();
        } else {
          const msg =
            data.errors.length > 0
              ? data.errors[0].errorMessage
              : 'Unknown error occurred';

          notify({
            type: 'error',
            title: msg,
          });
        }
      })
      .catch(error => {
        this.setLoading(false);
        this.setState({
          openSnackBar: true,
          snackbarMsg: error,
        });
        throw error;
      });
  };

  clearSnackbarError = () => {
    this.setState({
      openSnackBar: false,
      snackbarMsg: undefined,
    });
    if (this.IsOperationSuccess) this.goBack();
  };

  // Receive new array of roles
  rolesChanges = roles => {
    this.newRoles = roles;
    this.setState({
      newRoles: roles,
    });
  };

  setRestrictions = restrictions => {
    this.setState({
      newRestrictions: restrictions,
    });
  };

  userLoaded = user => {
    const selectedUser = user;
    this.setState({
      isLoading: false,
      userLoaded: true,
      activeUser: selectedUser,
    });
    this.getAllRoles(user.businessEntityId, selectedUser.countryCode);
  };

  goBack = () => {
    const { router } = this.context;
    router.push(Routes.USER_LISTING);
  };

  render() {
    const { openSnackBar, snackbarMsg, isLoading } = this.state;
    const {
      activeUser,
      isNew,
      userLoaded,
      bizEntityDataSource,
      availableCountries,
      isBizEntityLoaded,
      isClaimsLoaded,
      isRolesLoaded,
      newRoles,
      newRestrictions,
    } = this.state;

    const userId = this.props.params.id;
    const disableSaveButton =
      newRoles.length > 0 && newRestrictions.length > 0 ? false : true;
    return (
      <MainBody>
        <NitroSnackbar
          open={openSnackBar}
          message={snackbarMsg}
          autoHideDuration={4000}
          onRequestClose={this.clearSnackbarError}
        />

        {(isLoading || (!isNew && !userLoaded)) && (
          <div>
            <DisableCover />
            <NitroLoading center screen />
          </div>
        )}

        <NitroNavBar
          label="Back to user list"
          action={this.goBack}
          header
          variant="secondary"
        />

        <Container>
          {(isNew || userLoaded) && isBizEntityLoaded && (
            <UserDetails
              userId={userId}
              zoneName={activeUser.zoneName}
              user={activeUser}
              BizEntityDataSource={bizEntityDataSource}
              onChangeBusinessEntity={this.onUserDetailsChangeFunc}
              ref={el => (this.userDetailsRef = el)}
            />
          )}
        </Container>
        <Container>
          {(isNew || userLoaded) && isClaimsLoaded && (
            <UserClaims
              claims={this.state.claims}
              user={activeUser}
              ref={el => (this.userClaimsRef = el)}
              onChangeUserClaims={this.onChangeGetUserClaims}
            />
          )}
        </Container>
        <Container>
          {isBizEntityLoaded && (
            <UserRestrictions
              availableCountries={availableCountries}
              ref={el => (this.userRestrictionsRef = el)}
              businessEntityId={activeUser.businessEntityId}
              userid={this.props.params.id}
              countryCode={this.props.countryCode}
              setRestrictionAction={this.setRestrictions}
            />
          )}
        </Container>

        <Container>
          {isRolesLoaded && (
            <UserRole
              allRoles={this.state.allRoles}
              action={this.rolesChanges}
              userid={this.props.params.id}
              ref={el => (this.userRoleRef = el)}
            />
          )}
        </Container>

        <SubmitSection>
          {isBizEntityLoaded && isRolesLoaded && (
            <NitroButton
              block
              variant="primary"
              size="medium"
              label="Save"
              insideIconSize={14}
              insideIconPadding={20}
              borderRadius={0}
              boxShadow="button"
              action={this.submitUser}
              disabled={disableSaveButton}
            />
          )}
        </SubmitSection>
      </MainBody>
    );
  }
}

UserEdit.contextTypes = {
  router: PropTypes.object,
  location: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  notify: bindActionCreators(notify, dispatch),
  closeNotify: bindActionCreators(closeNotify, dispatch),
});

export default connect(
  null,
  mapDispatchToProps
)(UserEdit);



// WEBPACK FOOTER //
// ./src/features/admin/components/UserEdit.js